import { Argument } from '@automata/wfb-api/src/apis/wfbApiSchemas';

import { validateField } from '../../../utils';
import { DriverSchema, FieldValue } from '../types';

export const validateInstrument = (
  config: Record<string, FieldValue>,
  schema: DriverSchema
): Record<string, string | null> => {
  return Object.entries(schema).reduce((acc, [fieldName, fieldConfig]) => {
    const value = config[fieldName];
    if (value === undefined) return acc;
    const error = validateField(value, fieldConfig as Argument);
    return error ? { ...acc, [fieldName]: error } : acc;
  }, {});
};
